<template>
  <div style="width:100%;float:left;">
    <div style="width:100%;float:left;">
      <CCard>
        <CCardHeader>
          Orders
          <!-- <div style="float:right;" v-if="options"> -->
            <!-- <CButton size="sm" style="float:left;margin-top:2px;margin-right:2px;" :color="showMine ? 'info' : 'outline-info'" @click="clickShowMine()">Show Mine Only</CButton> -->
            <!-- <v-select style="width:250px;float:left;" :options="options" name="name" v-model="filter"></v-select> -->
          <!-- </div> -->
        </CCardHeader>
        <CCardBody>
          <div class="full text-center">
            <CInput v-model="customer" placeholder="Customer..." />
            <!-- <CInput v-model="customer" placeholder="Style..." /> -->
            <CInput v-model="artwork" placeholder="Artwork (split with comma)..." />
            <CInput v-model="styles" placeholder="Style(s) (split with comma)..." />
            <CInput v-model="color_codes" placeholder="Color Code (split with comma)" />

            <CButton size="sm" color="success" @click="getOrders()">Submit Search</CButton>
          </div>
          <!-- <h5 style="width:100%;float:left;text-align: center;font-size:13px;">Click on row to go to order</h5> -->
          <div style="width:100%;float:left;" v-if="!loading">
            <CDataTable v-if="orders"
              :items="orders"
              :fields="fields"
              :items-per-page="10"
              pagination
              column-filter
              sorter
              table-filter
              @row-clicked="rowClicked"
            >
              <template #check-header>
                  <input type="checkbox" :checked="checkAll()" @click="selectAll()" />
              </template>
              <template #order_id-header>
                  Order#
              </template>
              <template #as400_log_number-header>
                  Log#
              </template>
              <template #c="{item}">
                <td>
                  <div v-if="item.color_coding" style="width:20px;height:20px;" :style="'background-color:' + item.color_coding + ';'"></div>
                </td>
              </template>
              <template #order_items="{item}">
                <td>
                  {{ item.order_items.length }}
                </td>
              </template>
              <template #po_number="{item}">
                <td>
                  {{ item.order.po_number }}
                </td>
              </template>

              <template #check="{item}">
                <td>
                  <input type="checkbox" :checked="checkSelected(item)" @click="changeSelected(item)" />
                </td>
              </template>
              <!-- <template #customer="{item}">
                <td>
                  {{ item.order.customer_info.customer_name }}
                </td>
              </template> -->
              <template #status="{item}">
                <td>
                  <CBadge :color="configureColor(item)">{{ item.as400_status }}</CBadge>
                </td>
              </template>
              <template #show="{item}">
                <td>
                  <CButton size="sm" color="primary" @click="goToOrder( item )">View</CButton>
                </td>
              </template>
            </CDataTable>
          </div>
          <small-loader v-else-if="loading"></small-loader>
        </CCardBody>
      </CCard>
    </div>
    <CModal
      title="Production Notes"
      :show.sync="viewModal"
      size="lg"
    >
      <div style="width:100%;float:left;" v-if="modalItem">
        <production-notes :val="modalItem" :editable="false" from="modal" :fromSummary="true"></production-notes>
      </div>
    </CModal>
  </div>
</template>
<script>
import ProductionNotes from './../components/production_notes'
var methods = {}

methods.rowClicked = function (item) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

methods.checkSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    return 1
  } else {
    return 0
  }
}

methods.checkAll = function () {
  if (this.selected.length) {
    return 1
  } else {
    return 0
  }
}

methods.changeSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    this.selected.splice(this.selected.indexOf(item.order_group_id), 1)
  } else {
    this.selected.push(item.order_group_id)
  }
}

methods.selectAll = function () {
  if (this.selected.length) {
    this.selected = []
  } else {
    var arr = []
    this.orders.forEach(function (val) {
      arr.push(val.order_group_id)
    })
    this.selected = arr
  }
}

methods.rowClicked = function (item, index, column, e) {
  this.modalItem = item
  this.viewModal = true
}

methods.configureColor = function (item) {
  if (item) {
    var percent = ''
    switch(item.as400_status) {
      case 'Entered': {
        percent = 'info'
        break
      }
      case 'Needs Entered': {
        percent = 'secondary'
        break
      }
      case 'Waiting On Customer': {
        percent = 'danger'
        break
      }
      case 'Received': {
        percent = 'info'
        break
      }
      case 'In Process': {
        percent = 'danger'
        break
      }
      case 'Shipped': {
        percent = 'success'
        break
      }
      case 'On Hold': {
        percent = 'warning'
        break
      }
      case 'Voided': {
        percent = 'warning'
        break
      }
      case 'Canceled': {
        percent = 'danger'
        break
      }
      default: {
        percent = ''
        break
      }
    }
    return percent
  } else {
    return 0
  }
}

methods.getOrders = function () {
  this.loading = true
  const postData = {
    customer: this.customer,
    styles: this.styles,
    color_codes: this.color_codes,
    artwork: this.artwork
  }
  var aWork = this.artwork.toUpperCase()
  var s = this.styles.toUpperCase()
  var col = this.color_codes.toUpperCase()
  var artArr = this.artwork.split(',')
  var stylesArr = s.split(',')
  var colorsArr = col.split(',')
  var that = this
  console.log(colorsArr)
  axios.post(this.$apiAdress + '/api/orders/getSearchTable?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    // this.orders = response.data
    var arr = []
    // arr = response.data
    response.data.forEach(function (val) {
      var obj = that.getObject(val)
      arr.push(obj)
    //   val.order_items.forEach(function (item) {
    //     if (stylesArr.indexOf(item.style_name) > -1) {
    //       // obj.style_name = item.style_name
    //       var styleName = item.style_name
    //       item.order_item_locations.forEach(function (loc) {
    //         var n = loc.file_name.split('.')
    //         // console.log(n)
    //         if (artArr.indexOf(n[0]) > -1) {
    //           // console.log('yes')
    //           // obj.design = n[0]
    //           var desDescription = ''
    //           if (loc.tape_info) {
    //             desDescription = loc.tape_info.tape_name
    //           }
    //           var des = n[0]


    //           item.order_item_colors.forEach(function (color) {
    //             var obj = that.getObject(val)
    //             obj.design = des
    //             obj.style_name = styleName
    //             obj.description = desDescription
    //             if (that.color_codes) {
    //               if (colorsArr.indexOf(color.color_code) > -1) {
    //                 // var obj = that.getObject(val)
    //                 obj.color_code = color.color_code
    //                 arr.push(obj)
    //                 console.log('aaaa')
    //               } else {
    //                 console.log('zzzz')
    //               }
    //             } else {
    //               console.log('oooo')
    //               // var obj = that.getObject(val)
    //               obj.color_code = color.color_code
    //               arr.push(obj)
    //             }
    //           })
    //         }
    //       })
    //     }
    //   })
      
    })
    console.log('arrr')
    console.log(arr)
    this.orders = arr
    this.selected = []
    this.loading = false
  })
}

methods.getObject = function (val) {
  return {
        order_id: val.order_group_id,
        cc_number: val.cc_number,
        group: val.group_number,
        log: val.as400_log_number,
        customer_number: val.order.customer_info.customer_number,
        customer_name: val.order.customer_info.customer_name,
        production_notes: val.production_notes
        // color_code: ''
      }
}

methods.goToOrder = function (item) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

methods.clickShowMine = function () {
  this.showMine = !this.showMine
  window.localStorage.setItem('csrShowMine', this.showMine)
  this.getOrders()
}

methods.downloadOrders = function () {
  this.downloadLoading = true
    const postData = {
      orders: this.selected
    }
    axios.post(this.$apiAdress + '/api/orders/downloadAllOrdersOnPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      this.downloadLoading = false
      window.Swal.fire({
        type: 'success',
        title: 'Success',
        text: 'You will be emailed the orders shortly.'
      })
      this.selected = []
    }).catch(e => {
      console.log(e)
      window.Swal.fire({
        type: 'error',
        title: 'Error!',
        text: 'Something went wrong, please contact acoleman@paifashion.com if it keeps happening.'
      })
    })
}

export default {
    // ===Component name
    name: "SearchTable",
    // ===Props passed to component
    props: {},
    // ===Components used by this component
    components: {
      ProductionNotes
    },
    // ====component Data properties
    data(){
        return{
          orders: null,
          viewModal: false,
          modalItem: null,
          fields: [
            'order_id',
            'log',
            'customer_number',
            'customer_name',
            'cc_number',
            'group',
          ],
          options: ['Last 15 Days', 'Last 30 Days', 'Last 60 Days'],
          loading: false,
          filter: 'Last 15 Days',
          showMine: false,
          downloadLoading: false,
          selected: [],
          customer: '',
          artwork: '',
          styles: '',
          color_codes: '',
        }
    },
    watch: {
      'filter': function (newVal, oldVal) {
        this.getOrders()
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      // if (window.localStorage.getItem('csrShowMine')) {
      //   this.showMine = JSON.parse(window.localStorage.getItem('csrShowMine'))
      //   // this.getOrders()
      // } else {
      //   // this.getOrders()
      // }
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
